import { Injectable } from '@angular/core';
import { ApiBaseService } from '@shared/services/entities/api-base.service';
import {
  Permission,
  CreatePermissionPayload,
  UpdatePermissionPayload,
} from '@shared/models/entities/permission.model';

@Injectable({ providedIn: 'root' })
export class PermissionsService extends ApiBaseService<Permission> {

  constructor() {
    super('permissions');
  }

  /**
   * Crea un permiso. El backend genera id, organization, createdBy, etc.
   */
  async createPermission(payload: CreatePermissionPayload): Promise<Permission | null> {
    const body: CreatePermissionPayload = {
      operationType: 'single',
      ...payload,
      name: payload.name.trim().toUpperCase(),
      description: payload.description.trim(),
    };
    const response = await this.create(body as unknown as Permission);
    return Array.isArray(response.data) && response.data.length > 0
      ? response.data[0]
      : null;
  }

  /**
   * Actualiza un permiso. Solo viajan los campos incluidos en `payload`.
   */
  async updatePermission(payload: UpdatePermissionPayload): Promise<Permission | null> {
    if (!payload.id) {
      throw new Error('updatePermission requiere id.');
    }
    const body: UpdatePermissionPayload = {
      operationType: 'single',
      ...payload,
      ...(payload.name ? { name: payload.name.trim().toUpperCase() } : {}),
      ...(payload.description !== undefined ? { description: payload.description.trim() } : {}),
    };
    const response = await this.update(body as unknown as Permission);
    return Array.isArray(response.data) && response.data.length > 0
      ? response.data[0]
      : null;
  }

  /**
   * Soft-delete: marca deleted=true.
   */
  async softDeletePermission(id: string): Promise<Permission | null> {
    return this.updatePermission({ id, deleted: true });
  }

  /**
   * Cambia el estado activo/inactivo.
   */
  async toggleActive(id: string, active: boolean): Promise<Permission | null> {
    return this.updatePermission({ id, active });
  }
}